import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import moment, { Moment } from 'moment';

import THEME from 'theme';
import { SubmitButton } from 'components';
import { Banner, Heading, Text } from 'components/chroma';
import { SCREEN } from 'scenes/common/types/screen';

const toDMMMMYYYY = (date: Moment): string =>
  moment(date, 'YYYY-MM-DD').format('D MMMM YYYY');

const getQuoteExpiryDate = (
  polocyStartDate: string,
  effectiveEndDate: string
) =>
  toDMMMMYYYY(
    moment(polocyStartDate).isBefore(moment(effectiveEndDate))
      ? moment().add(60, 'days')
      : moment('2024-08-31')
  );

const SaveQuoteCompleteContainer = styled.div`
  margin-top: -36px;

  @media (min-width: ${SCREEN.MEDIUM}px) {
    margin-top: -56px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${THEME.TEXT.HEADING} !important;
  }

  .c-banner {
    height: 200px;

    @media (min-width: ${SCREEN.SMALL}px) {
      height: 280px;
    }

    @media (max-width: ${SCREEN.MEDIUM}px) {
      margin-left: -20px;
      margin-right: -20px;
    }

    @media (min-width: ${SCREEN.MEDIUM}px) {
      margin-left: -40px;
      margin-right: -40px;
    }
  }
`;

const Wrapper = styled.div`
  margin-top: 60px;
  text-align: left;
`;

const ButtonWrapper = styled.div`
  @media (max-width: ${SCREEN.EXTRA_SMALL}px) {
    margin-top: 66px;
  }
  margin-top: 60px;
`;

export const SaveQuoteComplete: FunctionComponent<{
  quoteNumber: string;
  onResumeQuote: () => void;
  saveQuoteEmailAddress: string;
  Image: FunctionComponent;
  polocyStartDate: string;
  effectiveEndDate: string;
}> = ({
  quoteNumber,
  onResumeQuote,
  saveQuoteEmailAddress,
  Image,
  polocyStartDate,
  effectiveEndDate,
}) => (
  <SaveQuoteCompleteContainer>
    <Banner width="viewport" padding={0}>
      <Heading size={1}>Thank you!</Heading>
      <Heading size={2}>We successfully saved your quote.</Heading>
      <Image />
    </Banner>
    <ButtonWrapper>
      <form onSubmit={onResumeQuote}>
        <SubmitButton enabled>Resume your quote</SubmitButton>
      </form>
    </ButtonWrapper>
    <Wrapper>
      <Heading size={3}>Quote No.: {quoteNumber}</Heading>
      <Text>
        A copy of the quote details and quote number has been emailed to{' '}
        <strong>{saveQuoteEmailAddress}</strong>. This quote has been saved
        automatically and will expire on{' '}
        <strong>{getQuoteExpiryDate(polocyStartDate, effectiveEndDate)}</strong>
        .
      </Text>
      <Text>
        You will need to enter the Quote No. to retrieve your saved quote.
      </Text>
    </Wrapper>
  </SaveQuoteCompleteContainer>
);

export default SaveQuoteComplete;
